import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Agent } from '@base/src/app/pages/configuration/panel/configuration.component';
import { QRInputAutocomplete } from 'src/app/models/qr-input-autocomplete.model';
import { QRInput } from 'src/app/models/qr-input.model';

@Component({
  selector: 'app-config-add-exception',
  templateUrl: './config-add-exception.component.html',
  styleUrls: ['./config-add-exception.component.scss'],
})
export class ConfigAddExceptionComponent implements OnInit {
  @Input() value: Agent[] = [];
  @Output() change: EventEmitter<any> = new EventEmitter<any>();

  inputAutocomplete: QRInputAutocomplete = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: 'Buscar',
    isCleanButtonVisible: true,
    options: [],
  };

  ngOnInit(): void {
    if (this.value) {
      this.value.sort((a: any, b: any) => (a.lastname > b.lastname ? 1 : -1));
      this.value.forEach((e: any) => {
        const item = e.name + ' ' + e.lastname;
        e.full = item;
        this.inputAutocomplete.options.push(item);
      });
    }
  }

  dropdownYearsChange(event: any) {
    if (event) {
      const item = this.value.find((e: any) => e.full == event);
      if (item) {
        const dto = {
          ids: [item.id],
          action: true,
        };
        this.change.emit(dto);
      }
    }
  }
}
